import { motion } from 'framer-motion';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube, FaLinkedin, FaPinterest } from 'react-icons/fa';
import { SOCIAL_LINKS } from '../../utils/constants';

const SocialLinks = ({ variant = 'default' }) => {
  const socialItems = [
    {
      name: 'Facebook',
      icon: FaFacebook,
      url: SOCIAL_LINKS.facebook,
      color: 'bg-[#1877F2]',
      hoverColor: 'hover:bg-[#166FE5]',
    },
    {
      name: 'Instagram',
      icon: FaInstagram,
      url: 'https://www.instagram.com/timesthetiny?igsh=MTI2emZsb2NhcHkyMw==',
      color: 'bg-gradient-to-br from-[#833AB4] via-[#FD1D1D] to-[#F77737]',
      hoverColor: 'hover:opacity-90',
    },
    {
      name: 'X',
      icon: FaTwitter,
      url: SOCIAL_LINKS.twitter,
      color: 'bg-[#1DA1F2]',
      hoverColor: 'hover:bg-[#1A91DA]',
    },
    {
      name: 'YouTube',
      icon: FaYoutube,
      url: SOCIAL_LINKS.youtube,
      color: 'bg-[#FF0000]',
      hoverColor: 'hover:bg-[#CC0000]',
    },
  ];

  if (variant === 'minimal') {
    return (
      <div className="flex gap-3">
        {socialItems.map((social, index) => (
          <motion.a
            key={index}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            whileHover={{ scale: 1.1, y: -3 }}
            whileTap={{ scale: 0.9 }}
            className={`w-10 h-10 ${social.color} ${social.hoverColor} rounded-full flex items-center justify-center text-white shadow-md transition-all`}
            aria-label={social.name}
          >
            <social.icon className="text-lg" />
          </motion.a>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      {socialItems.map((social, index) => (
        <motion.a
          key={index}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: index * 0.1 }}
          whileHover={{ scale: 1.05, y: -5 }}
          whileTap={{ scale: 0.95 }}
          className={`${social.color} ${social.hoverColor} text-white p-4 rounded-xl flex flex-col items-center gap-2 shadow-card transition-all`}
        >
          <social.icon className="text-3xl" />
          <span className="text-sm font-display font-semibold">{social.name}</span>
        </motion.a>
      ))}
    </div>
  );
};

export default SocialLinks;